module.exports = __webpack_public_path__ + "static/img/Partnerize1.4038d8fe.jpeg";